import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    // 
	{
		path: '/',
		name: 'index',
		component: () => import('../views/index.vue')
	},
	{
		path: '/home/register',
		name: 'home_register',
		component: () => import('../views/register.vue')
	},
	{
		path: '/home/reset',
		name: 'home_rest',
		component: () => import('../views/reset.vue')
	},
	{
		path: '/home/forget',
		name: 'forget',
		component: () => import('../views/forget.vue')
	},
	{
		path: '/pages/login',
		name: 'login',
		component: () => import('../views/home.vue')
	},
	{
		path: '/pages/about_us',
		name: 'about_us',
		component: () => import('../views/about_us.vue')
	},
	{
		path: '/pages/yw',
		name: 'pages_yw',
		component: () => import('../views/page_yw.vue')
	},
	{
		path: '/pages/sf',
		name: 'pages_sf',
		component: () => import('../views/page_sf.vue')
	},
	{
		path: '/user/index',
		name: 'user_index',
		component: () => import('../views/user_index.vue')
	},
	{
		path: '/user/new_infor',
		name: 'user_new_infor',
		component: () => import('../views/user_new_infor.vue')
	},
	{
		path: '/user/change_infor',
		name: 'user_change_infor',
		component: () => import('../views/user_change_infor.vue')
	},
	{
		path: '/user/notice',
		name: 'user_notice',
		component: () => import('../views/user_notice.vue')
	},
	{
		path: '/user/order_infor',
		name: 'user_order_infor',
		component: () => import('../views/user_order_infor.vue')
	},
	{
		path: '/user/infor',
		name: 'user_infor',
		component: () => import('../views/user_infor.vue')
	},
	
	{
		path: '/user/kjcx',
		name: 'user_kjcx',
		component: () => import('../views/user_kjcx.vue')
	},
	{
		path: '/user/kjcy',
		name: 'user_kjcy',
		component: () => import('../views/user_kjcy.vue')
	},
	{
		path: '/user/SCI',
		name: 'user_SCI',
		component: () => import('../views/user_SCI.vue')
	},
	{
		path: '/user/order',
		name: 'user_order',
		component: () => import('../views/user_order.vue')
	},
	{
		path: '/user/invoice',
		name: 'user_invoice',
		component: () => import('../views/user_invoice.vue')
	},
	{
		path: '/user/invoice_list',
		name: 'user_invoice_list',
		component: () => import('../views/user_invoice_list.vue')
	},
	{
		path: '/user/invoice_infor',
		name: 'user_invoice_infor',
		component: () => import('../views/user_invoice_infor.vue')
	},
	{
		path: '/user/change_invoice',
		name: 'user_change_invoice',
		component: () => import('../views/user_change_invoice.vue')
	},
	{
		path: '/user/invoice_new',
		name: 'user_invoice_new',
		component: () => import('../views/user_invoice_new.vue')
	},
	{
		path: '/notice',
		name: 'notice',
		component: () => import('../views/notice.vue')
	},
	
		
 //    {
 //        path: '/sale_fcst',
 //        name: 'sale_fcst',
 //        component: () => import('../views/sale_fcst.vue')
 //    },
	// {
	//     path: '/purchase_fcst',
	//     name: 'purchase_fcst',
	//     component: () => import('../views/purchase_fcst.vue')
	// },
	// {
	//     path: '/account_cost',
	//     name: 'account_cost',
	//     component: () => import('../views/account_cost.vue')
	// },
	
]

const router = new VueRouter({
  mode: 'hash',
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})


export default router


